export default __webpack_public_path__ + "images/56d546381f45c312358181ed9f2d4b39.jpg";